import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import { themesMixin } from '../../../utils/themes';
import WGS84Service from '../../../services/wgs84ProjectionService';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';
import mixinActionBoxStyles from '../../../components/core/mixinActionBoxStyles';
export default {
  name: 'ViewNiotaClassicGatewayManagementGWDetails',
  mixins: [themesMixin, mixinActionBoxStyles],
  data: function data() {
    return {
      plainAccounts: [],
      formDialog: false,
      gatewayData: {},
      showHeaderMap: false,
      pageYOffset: 0,
      tabItem: 'details',
      loading: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    headerBG: function headerBG() {
      return './img/gwmgmt.png';
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isIotHubManager: function isIotHubManager() {
      return this.permissions['IotHub.manage'];
    },
    gatewayId: function gatewayId() {
      return this.$route.params.gatewayId;
    },
    gatewayCoordinates: function gatewayCoordinates() {
      return get(this.gatewayData, 'coordinates.coordinates', [null, null]);
    },
    gatewayPolygon: function gatewayPolygon() {
      return get(this.gatewayData, 'polygon.coordinates', []);
    },
    showMap: function showMap() {
      if (!this.loading && get(this.gatewayData, 'coordinates.coordinates[1]')) {
        return this.hasValidCoordinate;
      }

      return false;
    },
    hasValidCoordinate: function hasValidCoordinate() {
      var coordinate = {
        lat: this.gatewayCoordinates[1],
        lon: this.gatewayCoordinates[0]
      };
      return WGS84Service.isValidWgs84(coordinate);
    }
  }),
  watch: {
    $route: function $route() {
      this.loading = true;
      this.gatewayData = {};
      this.loadGatewayDetails();
    }
  },
  mounted: function mounted() {
    this.loadGatewayDetails();
    this.getPlainAccounts();
  },
  methods: {
    getPlainAccounts: function getPlainAccounts() {
      var _this = this;

      this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        _this.accounts = accounts;
      }).catch(function (error) {
        console.error(error);
      });
    },
    breadCrumbsPath: function breadCrumbsPath() {
      if (get(this.gatewayData, 'account.name')) {
        return [this.permissions['all.manage'] ? {
          text: this.gatewayData.account.name,
          to: "/account-mgmt/".concat(this.gatewayData.account.id)
        } : this.gatewayData.account.name, this.gatewayData.title];
      }

      return [];
    },
    loadGatewayDetails: function loadGatewayDetails() {
      var _this2 = this;

      ApiService.gwMgmtGetDetails(this.gatewayId).then(function (gatewayData) {
        _this2.gatewayData = gatewayData;
        set(_this2.gatewayData, 'address.formatted_address', get(_this2.gatewayData, 'properties.formatted_address'));
      }).catch(function (error) {
        _this2.gatewayData = {};

        _this2.$snack(_this2.$i18n_t('NiotaClassic.GWMonitoring.snacks.fetchDetailsFailed'), 'error');

        console.error(error);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    updateDetails: function updateDetails(item) {
      this.gatewayData = cloneDeep(item);
    },
    viewAllDevices: function viewAllDevices() {
      this.$router.push({
        path: '/niota-classic/gw-mgmt'
      });
    },
    saveScrollOffset: function saveScrollOffset() {
      this.pageYOffset = window.pageYOffset;
    }
  }
};